import React from 'react'
import { Flex, Text } from 'components'

export default ({ type }) => (
  <Flex margin="0 0 48px 0" height="100%" center>
    <Text color="gray3">Loading {type || 'images'}...</Text>
  </Flex>
)
